export function parseJWT(token) {
  const base64Payload = token.split('.')[1];
  const payload: any = Buffer.from(base64Payload, 'base64');
  return JSON.parse(payload);
}
